import { render, staticRenderFns } from "./city_companyDetail.vue?vue&type=template&id=3d8acf7d&scoped=true&"
import script from "./city_companyDetail.vue?vue&type=script&lang=js&"
export * from "./city_companyDetail.vue?vue&type=script&lang=js&"
import style0 from "./city_companyDetail.vue?vue&type=style&index=0&id=3d8acf7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8acf7d",
  null
  
)

export default component.exports